<!-- Breadcrumb padronizado -->
<app-breadcrumb containerStyle="wide"></app-breadcrumb>

<div class="container">
  <!-- Debug: Mostrar estado do carregamento -->
  <div *ngIf="carregando" class="text-center p-3">
    <i class="fa fa-spinner fa-spin"></i> Carregando dados...
  </div>

  <!-- Debug: Mostrar se há dados do município -->
  <div *ngIf="!carregando && (!municipio || !municipio.municipio)" class="alert alert-info">
    Dados do município não encontrados. ID da cidade: {{ idCidade }}
  </div>

  <!-- Cabeçalho do Município -->
  <div class="municipio-header elemento-principal" *ngIf="!carregando && municipio && municipio.municipio">
    <div class="location-icon">
      <i class="fa fa-map-marker"></i>
    </div>
    <h2 class="municipio-nome">{{ municipio.municipio.nome?.toUpperCase() || 'Nome não disponível' }}</h2>
    <div class="success-badge" *ngIf="!hasPendenciasCadastro()">
      <i class="fa fa-check"></i>
      <span>Sucesso</span>
      <span class="item-count">0 item (s)</span>
    </div>
  </div>

  <!-- Badges de Status -->
  <div class="badges-container elemento-principal" *ngIf="!carregando">
    <div class="status-badge" 
         *ngFor="let badge of getBadges()"
         [style.background-color]="getBadgeColor(badge)"
         >         
      <span class="badge-text" [style.color]="getBadgeTextColor(badge)">{{ getBadgeText(badge).toUpperCase() }}</span>
    </div>
  </div>

  <!-- Estatísticas -->
  <div class="stats-container elemento-principal" *ngIf="!carregando && municipio && municipio.municipio">
    <div class="stat-item">
      <i class="fa fa-user-o"></i>
      <div class="stat-content">
        <span class="stat-number">{{ municipio.municipio.quantidade_usuarios || 0 }}</span>
        <span class="stat-label">Usuários</span>
      </div>
    </div>
    <div class="stat-item">
      <i class="fa fa-user-circle-o"></i>
      <div class="stat-content">
        <span class="stat-number">{{ municipio.municipio.quantidade_servidores || 0 }}</span>
        <span class="stat-label">Servidores</span>
      </div>
    </div>
    <div class="stat-item">
      <i class="fa fa-table"></i>
      <div class="stat-content">
        <span class="stat-number">{{ municipio.municipio.quantidade_orgaos || 0 }}</span>
        <span class="stat-label">Órgãos</span>
      </div>
    </div>
    <button class="btn btn-outline-primary btn-icon" (click)="openEditModal(editarDadosModal)">
      <i class="fa fa-edit"></i>
    </button>
 
  </div>

  <!-- Alerta de Pendências (Separado) -->
  <div class="alert alert-warning elemento-principal" *ngIf="!carregando && hasPendenciasCadastro()">
    <div class="alert-header">
      <i class="fa fa-exclamation-triangle"></i>
      <span>Pendências no Cadastro</span>
    </div>
    <ul class="pendencias-list">
      <li *ngFor="let pendencia of getPendenciasList()">
        {{ pendencia }}
      </li>
    </ul>
  </div>

  <!-- Quadro de Acesso Rápido -->
  <div class="acesso-rapido-container elemento-principal" *ngIf="!carregando">
    <h3 class="section-title">Acesso Rápido</h3>
    
    <!-- Lista de Módulos -->
    <div class="modulos-container">
      <div class="modulo-item" 
           *ngFor="let modulo of modulos"
           (click)="modulo.isModal && municipio?.municipio?.id ? openModalDocumento(cadastroAnexo, municipio.municipio.id) : navigateToModule(modulo)">
        <div class="modulo-icon">
          <i class="fa" [ngClass]="modulo.icone"></i>
        </div>
        <div class="modulo-content">
          <h4 class="modulo-titulo">{{ modulo.titulo }}</h4>
          <p class="modulo-descricao">{{ modulo.descricao }}</p>
        </div>
        <div class="modulo-arrow">
          <i class="fa fa-chevron-right"></i>
        </div>
      </div>
    </div>
  </div>

  <ngx-spinner></ngx-spinner>
</div>

<!-- Modal para Editar Dados do Cliente -->
<ng-template #editarDadosModal let-modal>
  <div class="modal-header border-0 pb-0">
    <h4 class="modal-title">Dados do Cliente</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  
  <!-- Linha divisória após título principal -->
  <hr class="modal-divider">
  
  <div class="modal-body">
    <h6 class="section-title">Informações Básicas</h6>
    
    <form #clienteForm="ngForm" novalidate>
      <div class="row">
        <div class="col-md-3">
          <div class="form-group mb-3">
            <label for="cep" class="form-label">CEP</label>
            <input type="text" id="cep" class="form-control" [(ngModel)]="dadosEdicao.cep" name="cep" 
                   mask="00000-000" placeholder="00000-000" required>
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-group mb-3">
            <label for="estado" class="form-label">ESTADO</label>
            <ng-select [items]="estados" bindLabel="nome" bindValue="sigla" 
                       [(ngModel)]="dadosEdicao.estado" name="estado" 
                       placeholder="RS" [clearable]="false" (change)="onEstadoChange()">
            </ng-select>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group mb-3">
            <label for="municipio_select" class="form-label">MUNICÍPIO</label>
            <ng-select [items]="municipios" bindLabel="nome" bindValue="nome" 
                       [(ngModel)]="dadosEdicao.municipio" name="municipio_select" 
                       placeholder="Canoas" [clearable]="false">
            </ng-select>
          </div>
        </div>
      </div>
      
      <div class="row">
        <div class="col-md-12">
          <div class="form-group mb-3">
            <label for="logradouro" class="form-label">LOGRADOURO</label>
            <input type="text" id="logradouro" class="form-control" [(ngModel)]="dadosEdicao.logradouro" 
                   name="logradouro" placeholder="Rua Exemplo" required>
          </div>
        </div>
      </div>
      
      <div class="row">
        <div class="col-md-6">
          <div class="form-group mb-3">
            <label for="numero" class="form-label">NÚMERO</label>
            <input type="text" id="numero" class="form-control" [(ngModel)]="dadosEdicao.numero" 
                   name="numero" placeholder="123" required>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group mb-3">
            <label for="complemento" class="form-label">COMPLEMENTO</label>
            <input type="text" id="complemento" class="form-control" [(ngModel)]="dadosEdicao.complemento" 
                   name="complemento" placeholder="PLACEHOLDER">
          </div>
        </div>
      </div>
      
      <div class="row">
        <div class="col-md-12">
          <div class="form-group mb-3">
            <label for="bairro" class="form-label">BAIRRO</label>
            <input type="text" id="bairro" class="form-control" [(ngModel)]="dadosEdicao.bairro" 
                   name="bairro" placeholder="PLACEHOLDER" required>
          </div>
        </div>
      </div>
    </form>
  </div>
  
  <div class="modal-footer border-0 pt-0">
    <hr class="footer-divider">
    <div class="d-flex">
      <button type="button" class="btn btn-outline-primary" (click)="modal.dismiss('Cancel')">
        Voltar
      </button>
      <button type="button" class="btn btn-primary"
              (click)="salvarDados(modal)"
              [disabled]="!dadosEdicao.cep || !dadosEdicao.estado || !dadosEdicao.municipio || !dadosEdicao.logradouro">
        Salvar
      </button>
    </div>
  </div>
  
  <ngx-spinner></ngx-spinner>
</ng-template>

<!-- Modal de Cadastro de Anexo FlaxFlow -->
<ng-template #cadastroAnexo let-modal>
  <div class="modal-header">
    <h5 class="modal-title">Novo Anexo</h5>
    <button
      type="button"
      class="close"
      aria-label="Close"
      (click)="closeModal(modal)"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <form #servForm="ngForm" novalidate>
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <button
              type="button"
              class="btn btn-block btn-outline-primary"
              (click)="fileInput.click()"
            >
              <i class="fa fa-upload"></i> Carregar Documento
            </button>

            <!-- Input file oculto -->
            <input
              #fileInput
              type="file"
              (change)="selecionaArquivo($event)"
              class="d-none"
              accept=".xls,.xlsx,.docx,.pdf,.doc"
              multiple
            />
          </div>
        </div>

        <!-- Radios abaixo do botão -->
        <div class="col-md-12 mt-3">
          <div class="form-check">
            <input
              class="form-check-input"
              type="radio"
              name="opcaoAnexo"
              id="processarEAnexar"
              [(ngModel)]="anexo.opcao"
              value="processarEAnexar"
            />
            <label class="form-check-label" for="processarEAnexar">
              Processar Documento e Anexar
            </label>
          </div>

          <div class="form-check">
            <input
              class="form-check-input"
              type="radio"
              name="opcaoAnexo"
              id="anexar"
              [(ngModel)]="anexo.opcao"
              value="anexar"
            />
            <label class="form-check-label" for="anexar">Anexar</label>
          </div>

          <div class="form-check">
            <input
              class="form-check-input"
              type="radio"
              name="opcaoAnexo"
              id="processar"
              [(ngModel)]="anexo.opcao"
              value="processar"
            />
            <label class="form-check-label" for="processar">
              Processar Documento
            </label>
          </div>
        </div>
      </div>

      <div *ngIf="statusEnvio" class="alert alert-info mt-3">
        {{ statusEnvio }}
      </div>

      <div class="modal-footer d-flex justify-content-between">
        <!-- Botão Voltar -->
        <button
          type="button"
          class="btn btn-outline-primary mt-3"
          (click)="closeModal(modal)"
        >
          Voltar
        </button>
        <!-- Botão Salvar -->
        <button
          type="button"
          class="btn btn-primary mt-3"
          (click)="cadastrarAnexo(modal)"
          [disabled]="!anexo.arquivos || anexo.arquivos.length === 0"
        >
          Adicionar
        </button>
      </div>
    </form>
  </div>
  <ngx-spinner></ngx-spinner>
</ng-template>
  